import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../layouts/Layout";
import ProtectedRoute from "./ProtectedRoute";
import Loader from "../components/elements/Loader";
import EventAttendeeList from "../pages/Event/EventAttendeeList/EventAttendeeList";
import TransactionList from "../pages/Transactions/Transactions";

// Lazy-loaded components

// Before Login
const Home = lazy(() => import("../pages/Home/Home"));
const Registration = lazy(() => import("../pages/Registration/Registration"));
const Login = lazy(() => import("../pages/Login/Login"));
const ForgotPassword = lazy(
  () => import("../pages/ForgotPassword/ForgotPassword")
);
const About = lazy(() => import("../pages/About/About"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound"));

const EventList = lazy(() => import("../pages/Event/EventList/EventList"));
const EventDetail = lazy(
  () => import("../pages/Event/EventDetail/EventDetail")
);
const EventVolunteerList = lazy(
  () => import("../pages/Event/EventVolunteerList/EventVolunteerList")
);
const AddEvent = lazy(() => import("../pages/Event/AddEvent/AddEvent"));

const Ngo = lazy(() => import("../pages/NGO/Ngo"));

const AdminDashboard = lazy(() => import("../pages/Admin/Dashboard/Dashboard"));

const AdminNgoList = lazy(
  () => import("../pages/Admin/ManageNgo/NgoList/NgoList")
);

const AdminAddNgo = lazy(
  () => import("../pages/Admin/ManageNgo/AddNgo/AddNgo")
);

const AdminInterestList = lazy(
  () => import("../pages/Admin/ManageInterest/InterestList")
);

const AdminCauseList = lazy(
  () => import("../pages/Admin/ManageCause/CauseList")
);

// After Login
const Profile = lazy(() => import("../pages/Profile/Profile"));

const AppRoutes = () => {
  return (
    // <Suspense fallback={<div>Loading...</div>}>
    <Suspense fallback={<Loader />}>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign-up" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <TransactionList />
              </ProtectedRoute>
            }
          />
          <Route path="/events" element={<EventList />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route
            path="/events/:id/volunteers"
            element={
              <ProtectedRoute>
                <EventVolunteerList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/:id/attendees"
            element={
              <ProtectedRoute>
                <EventAttendeeList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/add"
            element={
              <ProtectedRoute>
                <AddEvent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/:id/edit"
            element={
              <ProtectedRoute>
                <AddEvent />
              </ProtectedRoute>
            }
          />

          <Route path="/ngos" element={<Ngo />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/manage/ngos"
            element={
              <ProtectedRoute>
                <AdminNgoList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/manage/ngos/add"
            element={
              <ProtectedRoute>
                <AdminAddNgo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/manage/ngos/:id/edit"
            element={
              <ProtectedRoute>
                <AdminAddNgo />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/manage/interests"
            element={
              <ProtectedRoute>
                <AdminInterestList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/manage/causes"
            element={
              <ProtectedRoute>
                <AdminCauseList />
              </ProtectedRoute>
            }
          />

          {/* 404 Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Suspense>
  );
};

export default AppRoutes;
